import { createAction } from '@af-common/Common/_actions/Action';
import { IImageStore } from '../_stores/ImageStore';

export enum ImageListActionType {
	ImageListAdd		= "IMAGE_LIST_ADD",
	ImageListRemove		= "IMAGE_LIST_REMOVE",
}

export const ImageListAdd = (image:IImageStore) => createAction(ImageListActionType.ImageListAdd, {
	image: image
});

export const ImageListRemove = (id:string) => createAction(ImageListActionType.ImageListRemove, {
	id: id
});

export type ImageListAction = 
	ReturnType<typeof ImageListAdd>		|
	ReturnType<typeof ImageListRemove>